import { CollaborationEnabledProvider } from "@/features/collaboration/providers";
import Popover from "@components/ui/popover";
import Tooltip from "@components/ui/tooltip";
import { cn } from "@lib/cn";
import { IconMessagePlus } from "@tabler/icons-react";
import { useState } from "react";
import { Comments } from "./Comments";

const SettingsComments = ({
  id,
  className,
}: {
  id: string;
  className?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const triggerClass =
    "tw-ml-1.5 tw-flex tw-size-8 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg tw-transition-colors tw-duration-200 hover:tw-bg-blue-100";

  const TriggerIcon = (
    <div className={cn(triggerClass, className)}>
      <IconMessagePlus className="tw-size-4 tw-text-blue" stroke={1.5} />
    </div>
  );

  return (
    <CollaborationEnabledProvider fallback={TriggerIcon}>
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <Tooltip delay={100} placement="bottom">
          <Popover.Trigger asChild>
            <Tooltip.Trigger asChild>{TriggerIcon}</Tooltip.Trigger>
          </Popover.Trigger>
          <Tooltip.Content className="tw-z-[9999]">
            <Tooltip.Text>Add comment</Tooltip.Text>
          </Tooltip.Content>
        </Tooltip>
        <Popover.Content>
          <Comments id={id} close={() => setIsOpen(false)} />
        </Popover.Content>
      </Popover>
    </CollaborationEnabledProvider>
  );
};

export default SettingsComments;
